import { render, staticRenderFns } from "./ResponseTitle.vue?vue&type=template&id=1418475e&scoped=true"
import script from "./ResponseTitle.vue?vue&type=script&lang=js"
export * from "./ResponseTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418475e",
  null
  
)

export default component.exports